module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp13_7016.7e77533c.png";